import { Modal } from 'bootstrap';

const hideModal = (modelClassName: string) => {
  const modal = Modal.getOrCreateInstance(
    document.getElementById(modelClassName)
  );
  modal.hide();
};

export default hideModal;
